import ModalTypeEnum from 'Modals/ModalConstants';

export const openModal = (modalType, additionalData) => (
  (dispatch) => {
    dispatch({
      type: 'OPEN_MODAL',
      modalType,
      additionalData,
    });
  }
);

export const closeModal = modalType => (
  (dispatch) => {
    dispatch({
      type: 'CLOSE_MODAL',
      modalType,
    });
  }
);

export const finishModal = modalType => (
  (dispatch) => {
    switch (modalType) {
      case ModalTypeEnum.FREE_WRITE_LOADING_DOCUMENT: {
        const data = {
          percent: 95,
          interval: 0,
          content: {
            renderingFontsPercent: 100,
            loadingPagesPercent: 98,
            initializingEditorPercent: 100,
            finalizingPercent: 99,
          },
        };
        dispatch({ type: 'FINISH_MODAL', modalType, data });
        break;
      }
      default:
        dispatch({ type: 'FINISH_MODAL', modalType });
        break;
    }
  }
);

export const openFreeWriteExportDocumentModal = format => (
  (dispatch) => {
    dispatch(openModal(
      ModalTypeEnum.FREE_WRITE_EXPORT_DOCUMENT,
      { format },
    ));
  }
);

export const closeFreeWriteUploadModal = () => (
  (dispatch) => {
    dispatch({ type: 'CLOSE_MODAL', modalType: ModalTypeEnum.FREE_WRITE_UPLOAD_READY });
  }
);



// WEBPACK FOOTER //
// ./src-react/Modals/ModalActions.jsx